import { cached, tracked } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import BaseController from 'uplisting-frontend/pods/base/controller';

export const PROPERTIES_REASON = 'properties';

export default class NoAccessController extends BaseController {
  @service features!: Services['features'];

  queryParams = ['denied', 'reason'];

  @tracked denied: string | null = null;
  @tracked reason: string | null = null;

  @cached
  get areaLabel(): string | null {
    const segments = (this.denied ?? '').split('.').filter(Boolean);

    for (let length = segments.length; length > 0; length--) {
      const key = `route_names.${segments.slice(0, length).join('.')}`;

      if (this.intl.exists(key)) {
        return this.intl.t(this.#gatedKey(key) ?? key);
      }
    }

    return null;
  }

  @cached
  get titleKey(): string {
    if (this.denied) {
      return this.areaLabel
        ? 'no_access.denied.title'
        : 'no_access.denied.title_generic';
    }

    return this.reason === PROPERTIES_REASON
      ? 'no_access.properties.title'
      : 'no_access.title';
  }

  @cached
  get descriptionKey(): string {
    if (this.denied) {
      return 'no_access.denied.description';
    }

    return this.reason === PROPERTIES_REASON
      ? 'no_access.properties.description'
      : 'no_access.description';
  }

  #gatedKey(key: string): string | undefined {
    if (
      key === 'route_names.account.team' &&
      this.features.isTeamPresetsEnabled
    ) {
      return 'route_names.account.team_hub';
    }

    return undefined;
  }
}

declare module '@ember/controller' {
  interface Registry {
    'no-access': NoAccessController;
  }
}
